<template>
  <div class="m-b-16">
    <!----招标单信息------>
    <div v-if="showOrder" class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="招标单信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="biddingInfoOption"
            :el-attrs="{
              size: 'medium',
              column: 3,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:budget="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 万元</span>
              <money-in-cn :money="value * 10000" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!---选择中标人--->
    <div class="card no-padding-bottom">
      <div class="section">
        <div class="section-title">
          <base-section-title title="选择中标人" />
        </div>
        <div class="section-content">
          <el-form class="detail-form">
            <el-row>
              <el-col :span="10">
                <el-form-item label="中标方式：">
                  <span>
                    {{
                      bidWinWayDict.translate(orderInfo.winType).label || '-'
                    }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="报价方式：">
                  <span>
                    {{
                      offerTypeDict.translate(orderInfo.offerType).label || '-'
                    }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <supplier-result-detail
            class="m-t-16"
            :order-id="orderId"
            :winner-id="winner.winnerId"
            :supplier-id-lists="winner.supplierList"
            :win-type="orderInfo.winType"
            :offer-type="orderInfo.offerType"
            :winner-inform-type="winner.winnerInformType"
          />
          <el-form
            label-width="180px"
            class="detail-form p-b-16"
            label-suffix="："
          >
            <el-form-item label="上传评标报告或其他附件">
              <upload
                v-if="winner.winnerOtherFileIds"
                :file-id-before.sync="winner.winnerOtherFileIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!----代理服务费----->
    <div v-if="isEntrust" class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="代理服务费" />
        </div>
        <div class="section-content">
          <el-form
            ref="feeForm"
            label-width="140px"
            :inline="true"
            class="detail-content-width"
          >
            <el-form-item label="代理服务费(元)：">
              <span>
                {{
                  winner.agentServiceFee
                    ? strToThousands(winner.agentServiceFee)
                    : '-'
                }}
              </span>
              <money-in-cn
                :money="winner.agentServiceFee"
                style="display:inline-block;"
                class="m-l-20"
              />
            </el-form-item>
            <el-form-item label="收费标准：">
              <span>
                {{
                  agencyServiceChargeStandardDict.translate(winner.agentFeeType)
                    .label
                }}
              </span>
              <span
                v-if="
                  winner.agentFeeType ==
                    agencyServiceChargeStandardDict.FIXED_STANDARD.value
                "
                class="m-l-10"
              >
                {{
                  winner.agentFeeRate
                    ? strToThousands(winner.agentFeeRate)
                    : '-'
                }}
                <span v-if="winner.agentFeeType">
                  {{
                    agencyServiceChargeStandardDict.translate(
                      winner.agentFeeType
                    ).unit
                  }}
                </span>
                <money-in-cn
                  :money="winner.agentFeeRate"
                  style="display:inline-block;"
                  class="m-l-20"
                />
              </span>
              <span v-else class="m-l-10">
                {{ winner.agentFeeRate || '-' }}
                <span v-if="winner.agentFeeType">
                  {{
                    agencyServiceChargeStandardDict.translate(
                      winner.agentFeeType
                    ).unit
                  }}
                </span>
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!----中标结果通知---->
    <div class="card no-padding-bottom">
      <div class="section">
        <div class="section-title">
          <base-section-title title="中标结果通知" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="winner"
            :option="winnerInfoOption"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                whiteSpace: 'nowrap',
                width: '140px',
                justifyContent: 'flex-end'
              },
              contentStyle: {
                paddingLeft: '10px'
              }
            }"
          >
            <template v-slot:content>
              <u-editor
                v-if="winner.content"
                ref="editor"
                v-model="winner.content"
                :disabled="true"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="orderInfo.flowListing"
    />
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import SupplierResultDetail from '@/components/bid/BiddingSupplier/SupplierResultDetail'
import MoneyInCn from '@/components/common/MoneyInCn'
import Upload from '@/components/common/Upload/index'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'

import {
  bidWinWayDict,
  bidWhetherPublishCandidateDict,
  agencyServiceChargeStandardDict
} from '@/dictionary/project/bid'

import {
  projectTypeDict,
  releaseMediaDict,
  offerTypeDict,
  noticeReleaseStatusDict,
  bondBidRefundTypeDict
} from '@/dictionary/project/common'

import {
  fetchInviteBidDetailApi,
  getWinBidLatestApi,
  fetchWinBidApi
} from '@/api/procure/invite-bid'

import { strToThousands } from '@/utils/utils'
import DateUtils from '@/utils/date'
export default {
  components: {
    BaseSectionTitle,
    UEditor,
    SupplierResultDetail,
    MoneyInCn,
    Upload,
    RecordHistory,
    RecordRemark
  },

  props: {
    requestQuery: {
      type: Object,
      default: () => {}
    },

    showOrder: {
      type: Boolean,
      default: true
    },

    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      bidWhetherPublishCandidateDict,
      bidWinWayDict,
      offerTypeDict,
      bondBidRefundTypeDict,
      noticeReleaseStatusDict,
      agencyServiceChargeStandardDict,

      winner: {},
      orderInfo: {},
      biddingInfoOption: [
        {
          label: '招标名称',
          prop: 'orderName',
          elAttrs: { span: 3 }
        },
        {
          label: '招标估算',
          prop: 'budget',
          // filter: value => `${value} 万元`
          slotName: 'budget'
        },
        {
          label: '中标方式',
          prop: 'winType',
          filter: value => bidWinWayDict.translate(value).label
        },
        {
          label: '报价方式',
          prop: 'offerType',
          filter: value => offerTypeDict.translate(value).label
        },
        {
          label: '报名时间',
          prop: '',
          filter: value => {
            return DateUtils.getNormMinuteRange(
              value.signUpStartTime,
              value.signUpEndTime
            )
          }
        },
        {
          label: '开标时间',
          prop: 'openTime',
          isNormMinute: true
        },
        {
          label: '项目类型',
          prop: 'biddingType',
          filter: value => projectTypeDict.translate(value).label
        },
        {
          label: '发布媒体',
          prop: 'noticeMedium',
          filter: value => {
            const temp = (value || '').split(',')
            return (
              temp
                .map(mediumValue => {
                  return releaseMediaDict.translate(mediumValue)?.label
                })
                .filter(value => value)
                .join('、') || '-'
            )
          }
        },
        {
          label: '招标地点',
          filter: value => {
            if (value?.country === '中国') {
              return `${value?.province} - ${value?.city} - ${value?.area}`
            } else {
              return `${value?.country} - ${value?.foreignAddress}`
            }
          }
        },
        {
          label: '详细地址',
          prop: 'detailAddress'
        }
      ],

      winnerInfoOption: [
        {
          label: '发布日期',
          prop: 'noticeReleaseTime',
          isNormDay: true
        },
        {
          label: '发布状态',
          prop: 'noticeReleaseStatus',
          dictArray: noticeReleaseStatusDict.array,
          useTag: true
        },
        {
          label: '是否对外发布',
          prop: 'isPublicity',
          dictArray: bidWhetherPublishCandidateDict.array
        },
        {
          label: '公示标题',
          prop: 'title'
        },
        {
          label: '公告内容',
          prop: 'content',
          slotName: 'content'
        }
      ]
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },

    isEntrust() {
      return !!this.orderInfo?.projectId
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo || {}
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        this.getWinner()
        if (this.isByOrderId && val) {
          this.getInviteBidInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,
    /**
     * 获取招标单详情
     */
    async getInviteBidInfo() {
      try {
        const { data } = await fetchInviteBidDetailApi({
          orderId: this.orderId
        })
        this.orderInfo = data || {}
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    /**
     * 获取成交信息
     */
    getWinner() {
      if (!this.orderId) return
      if (this.requestQuery.winnerId) {
        this.getWinnerById()
      } else {
        this.getLatestWinner()
      }
    },

    /**
     * 获取最新的中标结果
     */
    async getLatestWinner() {
      try {
        const { data } = await getWinBidLatestApi(this.orderId)
        this.handleResult(data)
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 根据id获取成交信息
     */
    async getWinnerById() {
      try {
        const { data } = await fetchWinBidApi(
          this.orderId,
          this.requestQuery.winnerId
        )
        this.handleResult(data)
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 处理后端返回数据
     */
    handleResult(data) {
      const supplierNoticeList = data.supplierNoticeList || []
      const supplierNoticeObj = {}
      supplierNoticeList.forEach(k => {
        k.noticeFileIds = (k.noticeFileIds || []).join(',') || ''
        supplierNoticeObj[k.supplierId] = k
      })
      data.supplierList.forEach(el => {
        el.noticeFileIds = supplierNoticeObj[el.supplierId]?.noticeFileIds
      })
      const { winner, ...other } = data
      this.winner = { ...winner, ...other }
      this.$emit('setWinnerInfo', this.winner)
    }
  }
}
</script>
